import gql from 'graphql-tag';

export default gql`
mutation AppDecline(
        $uuid: String!
      ) {
    appDecline(uuid: $uuid) {
      __typename
    }
}
`;
